import React from 'react';
import ModelDownloadModal from '@/features/trainings/components/ModelDownloadModal.jsx';
import ConfigureDeploymentModal from '@/features/deployments/components/ConfigureDeploymentModal';
import DuplicateEcrPushConfirmModal from '@/features/deployments/components/DuplicateEcrPushConfirmModal';
import DuplicateDockerHubPushConfirmModal from '@/features/deployments/components/DuplicateDockerHubPushConfirmModal';

function downloadModelLabel(training) {
  if (!training) return null;
  return `${training.usecase_name || 'Model'} v${training.version}`;
}

/**
 * Modal chain owned by ``useConfigureDeploymentFlow``: format picker →
 * Configure Deployment → duplicate-registry confirm.
 *
 * Shared by the Models page, Evaluation's Model Details drawer, and the
 * task-page kebab Download action so those surfaces stay in lockstep.
 */
export default function ConfigureDeploymentFlowModals({ configureFlow, allUsecases }) {
  const isDockerHubPush =
    configureFlow.duplicatePushConfirm?.artifactType === 'dockerhub';

  return (
    <>
      <ModelDownloadModal
        open={!!configureFlow.downloadModalTraining}
        mode={configureFlow.downloadModalMode}
        onCancel={configureFlow.handleDownloadModalCancel}
        onConfirm={configureFlow.handleConfirmModelDownload}
        initialArtifactType={configureFlow.downloadModalArtifactType}
        modelLabel={downloadModelLabel(configureFlow.downloadModalTraining)}
        taskType={configureFlow.downloadModalTraining?.task_type ?? null}
      />
      <ConfigureDeploymentModal
        open={configureFlow.configureModal.open}
        mode={configureFlow.configureModal.mode}
        training={configureFlow.configureModal.training}
        artifactType={configureFlow.configureModal.artifactType}
        availableTrainings={configureFlow.eligibleTrainings}
        allUsecases={allUsecases}
        instancesCapErrorByTaskKey={configureFlow.configureModal.instancesCapErrorByTaskKey}
        focusedTaskKey={configureFlow.configureModal.focusedTaskKey}
        onClearInstancesCapErrorForTask={configureFlow.handleClearInstancesCapErrorForTask}
        onFocusedTaskKeyChange={configureFlow.handleFocusedTaskKeyChange}
        onCancel={configureFlow.handleConfigureCancel}
        onBack={configureFlow.handleConfigureBack}
        onConfirm={configureFlow.handleConfigureConfirm}
      />
      <DuplicateEcrPushConfirmModal
        open={!!configureFlow.duplicatePushConfirm && !isDockerHubPush}
        previousPush={configureFlow.duplicatePushConfirm?.previousPush}
        onCancel={configureFlow.handleDuplicatePushCancel}
        onConfirm={configureFlow.handleDuplicatePushConfirm}
        confirmLoading={configureFlow.duplicatePushSubmitting}
      />
      <DuplicateDockerHubPushConfirmModal
        open={!!configureFlow.duplicatePushConfirm && isDockerHubPush}
        previousPush={configureFlow.duplicatePushConfirm?.previousPush}
        onCancel={configureFlow.handleDuplicatePushCancel}
        onConfirm={configureFlow.handleDuplicatePushConfirm}
        confirmLoading={configureFlow.duplicatePushSubmitting}
      />
    </>
  );
}
